import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { authService } from '@/services/authService';

export const useAuth = () => {
  const { token, isAuthenticated, setToken } = useAuthStore();

  useEffect(() => {
    const initAuth = async () => {
      if (!token) {
        const newToken = await authService.getToken();
        if (newToken) {
          setToken(newToken);
        }
      }
    };
    initAuth();
  }, [token, setToken]);

  return { token, isAuthenticated };
};
